import hostingService from "./hostingService";
import analytics from "./analyticsService";

export const WELCOME_EVENT = "nameit:welcome-bonus";

// Called right after a guest links an account or a new account is created.
// The server decides whether the 150 coins are due; this only reports it.
export async function claimWelcomeBonus(source) {
  try {
    const result = await hostingService.claimWelcomeBonus(source);
    if (result.granted) {
      analytics.track("welcome_bonus_granted", { amount: result.amount });
      window.dispatchEvent(new CustomEvent(WELCOME_EVENT, { detail: result }));
    } else if (result.reason === "duplicate") {
      analytics.track("welcome_bonus_duplicate", {});
    }
    return result;
  } catch (error) {
    console.error("Welcome bonus claim failed:", error);
    return { granted: false, reason: "error" };
  }
}
